<template>
  <div class="container"
       v-loading="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.5)">
    <div v-if="msg" class="ouou-result">
      <img src="@/assets/course-list/result.png"/>
      <p>{{ msg }}</p>
    </div>
    <template v-else>
      <div class="black-bg g-flex g-row-center">
        <div class="total-width">
          <div class="g-flex g-col-top">
            <!--  左半部分信息，视频  -->
            <div class="left-part">
              <div class="g-flex g-col-top g-row-between">
                <div>
                  <!--  标题  -->
                  <div class="g-font-26 white-text g-font-weight-6" style="letter-spacing: 1px">
                    {{ detail.name }}
                  </div>
                  <!--  信息  -->
                  <div class="g-flex g-m-t-20 g-font-14">
                    <p>
                      <span class="green-text"> {{ detail.studyCount }}</span>
                      <span class="remark-text">人学习过</span>
                    </p>
                    <p class="remark-text g-m-l-20">{{ detail.chapterSectionInfo }}</p>
                    <p class="remark-text g-m-l-20">共{{ detail.duration }}</p>
                    <p class="remark-text g-m-l-20">{{ detail.createTime }}</p>
                  </div>
                  <!--  类型标签  -->
                  <div class="g-flex g-font-14">
                    <div class="types-tag g-m-t-10" v-if="detail.isGood">精品课程</div>
                    <template v-for="item in detail.classifyName.split(',')">
                      <div class="types-tag g-m-t-10">{{ item }}</div>
                    </template>
                  </div>
                </div>
                <div class="g-m-r-50" v-if="!detail.isBuy">
                  <!--  价格  -->
                  <div class="red-text g-font-28 g-font-weight-6">
                    ￥{{ detail.price }}
                  </div>
                  <!--  立即购买  -->
                  <div class="submit-btn g-m-t-30" @click="doBuy">
                    立即购买
                  </div>
                </div>
              </div>
              <!--  视频  -->
              <div class="g-m-t-20 g-rela video-container">
                <!--              <video id="media" :poster="detail.cover" @pause="videoPaused" @play="videoPlay" @click="videoClick" @ended="videoEnd"  :controls="showControls" preload>-->
                <!--                <source :src="currentVideo.url" type="video/mp4">-->
                <!--              </video>-->
                <div id="video" style="width: 100%;height: 100%;"></div>

                <!--  播放按钮  -->
                <img :src="detail.cover" v-if="!isPlaying" class="play-btn" alt="">

                <!--  试看提示  -->
                <div class="g-abso demo-row" style="z-index: 1000;" v-if="hint">
                  <div class="g-p-16 g-flex">
                    <i class="el-icon-warning g-font-18 yellow-text"></i>
                    <span class="yellow-text g-m-l-10 g-font-16">试看已结束，</span>
                    <span class="white-text">购买即可学习全部课程。</span>
                    <div class="buy-btn g-flex-right" @click="doBuy">立即购买</div>
                  </div>
                </div>
              </div>
            </div>

            <!--  右半部分考试，课程目录  -->
            <div class="right-part g-rela">
              <!--  立即考试  -->
              <div class="g-m-b-27 exam-box">
                <div class="test-card " v-if="detail.isTestPaper">
                  <div class="g-p-10 g-flex g-col-top ">
                    <img :src="detail.cover" class="test-img" alt="">
                    <div class="g-m-l-10 g-full-width">
                      <p class="white-text g-font-14">{{ detail.examName }}</p>
                      <div class="g-m-t-12 g-flex g-row-between g-col-top">
                        <div class="level-tag">
                          {{ detail.grade }}
                        </div>
                        <div class="submit-btn" v-if="detail.mediaProgress === 100 && !detail.isExam && detail.paperId"
                             @click="$router.push({
                        name:'examination-detail',
                        query: {id:detail.paperId}
                      })">
                          立即考试
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <!--  课程  -->
              <div class="list-container">
                <div class="list-title g-rela white-text">
                  课程目录
                </div>
                <div class="line g-rela">
                  <div class="title-line"></div>
                </div>

                <!--  课程列表  -->
                <div class="course-list">
                  <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item :title="item.name" :name="item.name+index" v-for="(item,index) in detail.chapter"
                                      :key="index">
                      <div class="g-p-10">
                        <div class="course-item"
                             :class="{'course-item-bottom':subIndex !== item.children.length-1}"
                             v-for="(sub,subIndex) in item.children"
                             @click="selectCourse(sub)"
                             :key="subIndex">
                          <div class="sub-text g-font-14" :class="{'yellow-text':sub.id === selected.id}">{{ sub.name }}
                          </div>
                          <div v-if="sub.id === selected.id">
                            <div class="g-m-t-6 g-font-12 g-flex">
                              <p class="sub-text ">{{ sub.durationStr }}</p>
                              <p class="green-text g-m-l-15" v-if="detail.isBuy && sub.status === 0">已学完</p>
                              <p class="green-text g-m-l-15" v-if="sub.status === 1">{{ sub.mediaProgress }}%</p>
                              <div class="try-btn g-flex-right" @click="handleTryAndSee(sub,index,subIndex)"
                                   v-if="!detail.isBuy && sub.isTrySee">试看
                              </div>
                              <p class="green-text g-m-l-15" v-if="detail.isBuy &&  sub.status ===2"> 未学习</p>
                              <div class="try-btn g-flex-right" @click="handleTryAndSee(sub,index,subIndex)"
                                   v-if="detail.isBuy && (sub.status === 1||sub.status === 0 ||sub.status === 2)">学习
                              </div>
                            </div>
                            <!--  附件下载  -->
                            <div class="files-list" v-if="JSON.parse(sub.file).length">
                              <div class="files-item g-m-t-5 g-font-12 g-flex"
                                   v-for="(file,fileIndex) in JSON.parse(sub.file)" :key="fileIndex">
                                <!--  建议用a标签处理下载，单独写点击事件下载也行  -->
                                <img src="@/assets/find-careers/pdf-img.png" class="pdf-img" alt="">
                                <a class="g-m-l-10" style="text-decoration:none;color: #A1A9B2" :href="file.value"
                                   target="blank">{{ file.label }}</a>
                                <p class="g-flex-right">{{ fileRenderSize(file.size) }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  课程详情  -->
      <div class="g-flex g-row-center">
        <div class="total-width white-bg g-m-t-50">
          <div class="g-flex g-row-center">
            <div class="title-bg g-font-24 g-flex g-row-center white-text g-rela">
              课程详情
            </div>
          </div>
          <div class="g-m-t-40">
            <!--  富文本内容  -->
            <div class="g-p-20" v-html="detail.content">
            </div>
          </div>
        </div>
      </div>
      <!--  付款  -->
      <popup-pay-box ref="payPopup" :courseId="courseId" :price="detail.price" @success="queryDetail"></popup-pay-box>
    </template>

  </div>
</template>

<script>
import PopupPayBox from "@/components/pay-popup";
import {getDetail, sectionRecordSubmit} from '@/api/education/course'
import "@/assets/ckplayer/css/ckplayer.css";
import ckplayer from "@/assets/ckplayer/js/ckplayer.js";
import {renderSize} from "@/utils/file";

export default {
  name: "course-detail",
  components: {PopupPayBox},
  data() {
    return {
      showControls: false,//菜单只在第一次学习完后显示
      player: null,//视频对象
      isPlaying: false,//是否在播放
      isLogin: false,//是否登录
      isBought: false,//是否购买
      timer: null,//定时器
      courseId: null,//课程id
      hint: false,//课程id
      loading: false,//加载
      activeNames: '1',//折叠面板下标
      selected: '',
      detail: {
        classifyName: ''
      },
      currentVideo: {},
      currentTime: 0,
      currentChapterIndex: 0,
      msg: "",
      currentSectionIndex: 0,
      richText: `<p>富文本</p>`
    }
  },
  created() {
    this.courseId = this.$route.params.id

  },
  mounted() {
    this.queryDetail()
  },
  methods: {
    fileRenderSize(v) {
      return renderSize(v);
    },
    //播放
    handleTryAndSee(v, chapterIndex, sectionIndex) {

      this.selected = v.id
      this.currentVideo = v
      //节下标
      this.currentChapterIndex = chapterIndex
      //章下标
      this.currentSectionIndex = sectionIndex

      this.isPlaying = true
      this.hint = false
      //定义一个变量：videoObject，用来做为视频初始化配置
      var videoObject = {
        container: '#video', //“#”代表容器的ID，“.”或“”代表容器的class
        video: v.url,//视频地址
        seek: v.playDuration,//默认需要跳转的秒数
        autoplay: true,//是否自动播放
        webFull: true,//是否启用页面全屏按钮，默认不启用
        rightBar: true,//是否开启右边控制栏
        smallWindows: true,//是否启用小窗口模式
        smallWindowsDrag: true,//小窗口开启时是否可以拖动
        screenshot: true,//截图功能是否开启
        menu: null,//右键菜单
        documentFocusPause: true,//窗口失去焦点后暂停播放
        keyVolume: 1,//是否启用键盘控制音量调节，0=不启用，1=启用，2=全屏时才启用
        playbackrateOpen: false,//是否开启控制栏倍速选项
      };
      if (v.playDuration === 0) {
        videoObject.timeScheduleAdjust = 5
      }
      this.player.into(videoObject);
      //未购买，是观看。
      const bool = !this.detail.isBuy && v.isTrySee
      if ((bool)) {
        //是否可调节播放进度,0不启用，1是启用，2是只能前进（向右拖动），3是只能后退，4是只能前进但能回到第一次拖动时的位置，5是看过的地方可以随意拖动
        this.player.vars('timeScheduleAdjust', 5);
      }
      this.player.seek((obj) => {
        if (obj.state === 'seeking') {
          let timeScheduleAdjust;
          if ((bool) || v.status === 1 || v.status === 2) {
            timeScheduleAdjust = 5
          } else if (v.status === 0) { //已学完
            timeScheduleAdjust = 1
          } else {
            timeScheduleAdjust = 5
          }
          //是否可调节播放进度,0不启用，1是启用，2是只能前进（向右拖动），3是只能后退，4是只能前进但能回到第一次拖动时的位置，5是看过的地方可以随意拖动
          this.player.vars('timeScheduleAdjust', timeScheduleAdjust);
        }
      })
      // if(!this.detail.isBuy && v.isTrySee){
      //   this.player.bar(false);
      // }
      //监听播放
      this.player.play(() => {
        this.hint = false
        this.timer = setInterval(() => {
          this.doRecord();
        }, 1000 * 5)
      })
      //监听暂停
      this.player.pause(() => {
        clearInterval(this.timer)
      })
      //监听播放结束
      this.player.ended(() => {
        clearInterval(this.timer)
        if (!this.detail.isBuy && this.currentVideo.isTrySee) {
          this.hint = true
          this.player.bar(false)
        } else {
          this.doRecord();
        }
      });
    },
    // 记录播放进度
    doRecord() {
      if (this.detail.isBuy) {
        //已购买观看
        // 记录播放进度
        sectionRecordSubmit({
          courseInfoId: this.courseId,
          courseSectionId: this.currentVideo.id,
          playDuration: this.player.time(),
        }).then(res => {
          this.detail.chapter[this.currentChapterIndex].children[this.currentSectionIndex].mediaProgress = res.mediaProgress
          this.detail.chapter[this.currentChapterIndex].children[this.currentSectionIndex].status = res.status
          debugger
          if (res.courseMediaProgress === 100) { //学习完毕修改状态
            this.detail.mediaProgress = res.courseMediaProgress
            this.detail.paperId = res.paperId
            this.detail.examName = res.examName
            this.detail.isExam = res.isExam
          }
        })
      }
    },
    queryDetail() {
      this.loading = true
      getDetail(this.courseId).then(res => {
        this.loading = false
        this.detail = res
        this.initVideo()
      }, err => {
        this.loading = false
        if (err.data.code === 500) {
          this.msg = err.data.msg
        }
      })
    },
    // 初始化播放对象
    initVideo() {
      this.player = new ckplayer()
    },

    // 折叠change事件
    handleChange(e) {
      console.log(e)
    },

    //  选择课程
    selectCourse(val) {
      /**
       * 需要先判断用户是否登录并且购买了该课程
       */
      if(!this.detail.isBuy && !val.isTrySee){
        this.$confirm('该课程是收费课程, 需要购买了才可以学习', '提示', {
          confirmButtonText: '立即购买',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        this.doBuy()
        }).catch(() => {
        });
      }
      this.selected = val
    },
    //  购买
    doBuy() {
      this.$refs.payPopup.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.ouou-result {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 200px 0;
  img {
    border: 1px  dashed #A1A9B2;
  }
  p{
    margin-top: 10px;
    color: black;
  }
}

.black-bg {
  background: #000;
  padding: 30px 0;
}

.left-part {
  width: 865px;

  .types-tag {
    background: rgba(255, 255, 255, 0.10);
    border-radius: 5px;
    padding: 7px 28px;
    color: #FFC02C;
    margin-right: 10px;
  }

  .red-text {
    color: #FF5918;
  }

  .submit-btn {
    padding: 5px 22px;
  }

  .video-container {
    width: 100%;
    height: 470px;

    video {
      object-fit: fill;
      width: 100%;
      height: 470px;
    }

    .play-btn {
      position: absolute;
      z-index: 1;
      //left: 46%;
      top: 0%;
      width: 100%;
      height: 100%;
    }
  }

  .demo-row {
    width: 100%;
    background: rgba(0, 0, 0, 0.60);
    left: 0;
    bottom: 0;

    .buy-btn {
      background: #eea906;
      border-radius: 5px;
      color: #fff;
      font-size: 14px;
      padding: 4px 12px;

      &:hover {
        cursor: pointer;
        background: rgba($color: #eea906, $alpha: 0.8);
      }
    }
  }
}

.right-part {
  width: 335px;

  .test-card {
    background: #1b2128;
    border-radius: 5px;
  }

  .exam-box {
    height: 107px;
  }

  .test-img {
    width: 86px;
    height: 86px;
    border-radius: 10px;
  }

  .level-tag {
    background: rgba(0, 0, 0, 0.10);
    border-radius: 20px;
    color: #fff;
    padding: 3px 15px;
    font-size: 12px;
  }

  .submit-btn {
    padding: 3px 10px;
  }

  .list-container {
    background: #1b2128;
    height: 100%;

    .list-title {
      padding: 15px;
    }

    .line {
      height: 1px;
      width: 100%;
      background: #2E3741;

      .title-line {
        position: absolute;
        left: 15px;
        top: -3px;
        height: 3px;
        width: 64px;
        background: #f7d147;
      }
    }
  }

  .course-list {
    padding: 0 15px;
    height: 400px;
    overflow-y: auto;
  }

  ::v-deep .el-collapse {
    border: none;
  }

  ::v-deep .el-collapse-item__header {
    background-color: #1b2128;
    color: #fff;
    border-bottom: 1px solid #A1A9B2;
  }

  ::v-deep .el-collapse-item__content {
    background: #0f1419;
    border-radius: 5px;
    color: #666;
    padding-bottom: 0;
  }

  ::v-deep .el-collapse-item__wrap {
    background-color: initial;
    border: none;
  }

  .course-item {
    padding: 10px 0;
  }

  .course-item-bottom {
    border-bottom: 1px dashed #1c232c;
  }

  .try-btn {
    color: #08d1ad;
    background: rgba(8, 209, 173, 0.05);
    border-radius: 20px;
    font-size: 12px;
    padding: 3px 12px;
    cursor: pointer;
  }

  .files-item {
    padding: 10px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 5px;
    color: #A1A9B2;
    cursor: pointer;
  }

  .pdf-img {
    width: 16px;
    height: 16px;
  }
}

.white-bg {
  background: #ffffff;
  border-radius: 5px;

  .title-bg {
    width: 307px;
    height: 91px;
    margin-top: -20px;
    background-image: url("../../assets/course-list/course-title-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
</style>
